import { create } from 'zustand';

/**
 * FRONT-562: a transient signal to open the coding-session window for a specific
 * session, raised from elsewhere in the app (the background viewer's coding
 * card). home.tsx watches `openRequest`, opens the modal with it as the
 * initial session, then clears it.
 *
 * FRONT-1550: `returnTo` rides along — the page path (+ query/hash) the
 * request was raised from, or `null` when it was raised from Home itself.
 * home.tsx stashes it and navigates back to it when the coding window
 * closes, so closing a coding window opened from elsewhere returns the user
 * to that page instead of leaving them on Home.
 */
interface CodingOpenRequest {
  /** `null` means "no particular session": the window resumes the most
   *  recent build, or starts a fresh one if there has never been a build.
   *  That is what the top bar's Build button raises (2026-09-01) — the same
   *  thing the chat composer's coding icon used to do locally on Home before
   *  it was retired in favour of that button. */
  sessionId: string | null;
  returnTo: string | null;
}

interface CodingOpenState {
  openRequest: CodingOpenRequest | null;
  requestOpenCoding: (sessionId: string | null, returnTo?: string | null) => void;
  clearOpenCoding: () => void;
}

export const useCodingOpenStore = create<CodingOpenState>((set) => ({
  openRequest: null,
  requestOpenCoding: (sessionId, returnTo = null) => set({ openRequest: { sessionId, returnTo } }),
  clearOpenCoding: () => set({ openRequest: null }),
}));
